(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-v1"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Ocultar iconos de acción inmediatamente en todos los lugares
  function hideActionIcons() {
    // Home (container-v2)
    var $iconsHome = jQuery('.section-product-v1 .product-icon-action, .container-v2 .product-icon-action');
    if ($iconsHome.length > 0) {
      $iconsHome.hide().css({
        'display': 'none !important',
        'visibility': 'hidden !important',
        'opacity': '0 !important',
        'pointer-events': 'none !important'
      });
    }
    
    // Collections (col-lg-12)
    var $iconsCollections = jQuery('.col-lg-12 .product-icon-action');
    if ($iconsCollections.length > 0) {
      $iconsCollections.hide().css({
        'display': 'none !important',
        'visibility': 'hidden !important',
        'opacity': '0 !important',
        'pointer-events': 'none !important'
      });
    }
    
    // Related products (related-tabs)
    var $iconsRelated = jQuery('.related-tabs .product-icon-action, .related-tabs.pt-4 .product-icon-action, .related-tabs.pt-lg-5 .product-icon-action');
    if ($iconsRelated.length > 0) {
      $iconsRelated.hide().css({
        'display': 'none !important',
        'visibility': 'hidden !important',
        'opacity': '0 !important',
        'pointer-events': 'none !important'
      });
    }
  }
  
  function initProductCarousel() {
    var $carousel = jQuery('.js_section_product');
    
    if ($carousel.length === 0) {
      return;
    }
    
    // Ocultar iconos antes de inicializar
    hideActionIcons();
    
    // Si ya está inicializado, destruirlo primero
    if ($carousel.hasClass('slick-initialized')) {
      try {
        $carousel.slick('unslick');
      } catch(e) {
        $carousel.removeClass('slick-initialized');
        $carousel.find('.slick-track').remove();
      }
    }
    
    // Esperar un momento antes de reinicializar
    setTimeout(function() {
      $carousel.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 900,
        autoplay: false,
        autoplaySpeed: 3500,
        dots: false,
        arrows: false,
        swipe: true,
        draggable: true,
        prevArrow:'<button type="button" class="prev-slide slick-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.0003 20.67C14.8103 20.67 14.6203 20.6 14.4703 20.45L7.95027 13.93C6.89027 12.87 6.89027 11.13 7.95027 10.07L14.4703 3.55002C14.7603 3.26002 15.2403 3.26002 15.5303 3.55002C15.8203 3.84002 15.8203 4.32002 15.5303 4.61002L9.01027 11.13C8.53027 11.61 8.53027 12.39 9.01027 12.87L15.5303 19.39C15.8203 19.68 15.8203 20.16 15.5303 20.45C15.3803 20.59 15.1903 20.67 15.0003 20.67Z" fill="#292D32"/></svg></button>',
        nextArrow:'<button type="button" class="next-slide slick-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.90961 20.67C8.71961 20.67 8.52961 20.6 8.37961 20.45C8.08961 20.16 8.08961 19.68 8.37961 19.39L14.8996 12.87C15.3796 12.39 15.3796 11.61 14.8996 11.13L8.37961 4.61002C8.08961 4.32002 8.08961 3.84002 8.37961 3.55002C8.66961 3.26002 9.14961 3.26002 9.43961 3.55002L15.9596 10.07C16.4696 10.58 16.7596 11.27 16.7596 12C16.7596 12.73 16.4796 13.42 15.9596 13.93L9.43961 20.45C9.28961 20.59 9.09961 20.67 8.90961 20.67Z" fill="#292D32"/></svg></button>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });
      
      // Ocultar iconos después de inicializar también
      hideActionIcons();
    }, 50);
  }
  
  // Ejecutar cuando jQuery y Slick estén listos
  function waitForSlick() {
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      // Ocultar iconos inmediatamente
      hideActionIcons();
      
      // Esperar a que el script original se ejecute primero
      setTimeout(function() {
        initProductCarousel();
      }, 1500);
    } else {
      // Si Slick no está disponible, esperar un poco más
      setTimeout(waitForSlick, 100);
    }
  }
  
  // Ocultar iconos inmediatamente si jQuery ya está disponible
  if (typeof jQuery !== 'undefined') {
    hideActionIcons();
    jQuery(document).ready(function($) {
      hideActionIcons();
      waitForSlick();
      
      // Ocultar iconos continuamente cada 500ms para asegurar que no aparezcan
      setInterval(function() {
        hideActionIcons();
      }, 500);
      
      // Forzar tipografía D-DIN y color negro
      function forceTypography() {
        jQuery('.section-product-v1 .product-item-v1 .title-product, .section-product-v1 .product-item-v1 .title-product a').css({
          'font-family': '"D-DIN", "DIN", sans-serif',
          'font-size': '14px',
          'color': '#000000',
          'opacity': '1'
        });
        
        jQuery('.section-product-v1 .product-item-v1 .price-product, .section-product-v1 .product-item-v1 .price-product .price').css({
          'font-family': '"D-DIN", "DIN", sans-serif',
          'font-size': '14px',
          'color': '#000000',
          'opacity': '1'
        });
        
        // Eliminar hover gris
        jQuery('.section-product-v1 .product-item-v1, .section-product-v1 .product-item-v1 .info-product, .section-product-v1 .product-item-v1 .product').css({
          'background': 'transparent',
          'background-color': 'transparent'
        });
      }
      
      forceTypography();
      setInterval(forceTypography, 500);
    });
  } else {
    window.addEventListener('load', function() {
      if (typeof jQuery !== 'undefined') {
        hideActionIcons();
        waitForSlick();
        
        // Ocultar iconos continuamente cada 500ms para asegurar que no aparezcan
        setInterval(function() {
          hideActionIcons();
        }, 500);
        
        // Forzar tipografía D-DIN y color negro
        function forceTypography() {
          jQuery('.section-product-v1 .product-item-v1 .title-product, .section-product-v1 .product-item-v1 .title-product a').css({
            'font-family': '"D-DIN", "DIN", sans-serif',
            'font-size': '14px',
            'color': '#000000',
            'opacity': '1'
          });
          
          jQuery('.section-product-v1 .product-item-v1 .price-product, .section-product-v1 .product-item-v1 .price-product .price').css({
            'font-family': '"D-DIN", "DIN", sans-serif',
            'font-size': '14px',
            'color': '#000000',
            'opacity': '1'
          });
          
          // Eliminar hover gris
          jQuery('.section-product-v1 .product-item-v1, .section-product-v1 .product-item-v1 .info-product, .section-product-v1 .product-item-v1 .product').css({
            'background': 'transparent',
            'background-color': 'transparent'
          });
        }
        
        forceTypography();
        setInterval(forceTypography, 500);
      }
    });
  }
  
  // Reinicializar si la sección se carga dinámicamente en el editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId === '{{ section.id }}') {
        setTimeout(function() {
          hideActionIcons();
          initProductCarousel();
        }, 500);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
